var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#DB0011",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 15.0442H11.8495L11.8505 15.0563L12.9008 27.9743C12.9042 29.2632 13.9684 30.3242 15.2569 30.3242H23.7152C25.0036 30.3242 26.068 29.2897 26.0713 27.9743L27.1216 15.0563L27.122 15.0564V15.0442C27.122 14.9096 27.0978 14.7289 26.9585 14.6052C26.8714 14.4587 26.7156 14.3944 26.5536 14.3944H12.473C12.3052 14.3944 12.1244 14.4612 12.0112 14.6126L12.1313 14.7025L12.0116 14.6121C11.9194 14.7343 11.85 14.8966 11.85 15.0442ZM24.8803 27.9034L24.8798 27.9034V27.9157V27.9424C24.8798 28.5686 24.3693 29.0791 23.743 29.0791H15.2837C14.6575 29.0791 14.147 28.5686 14.147 27.9424V27.9157H14.1475L14.1465 27.9037L13.1611 15.6404H25.891L24.8803 27.9034Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.527 11.7139H23.1307V10.7865C23.1307 9.70376 22.2473 8.85 21.1942 8.85H21.1942L17.8326 8.85103C17.8326 8.85103 17.8326 8.85103 17.8325 8.85103C16.7499 8.85105 15.8961 9.73441 15.8961 10.7875V11.7149L12.4731 11.7139H12.473C12.1275 11.7139 11.85 11.9914 11.85 12.337C11.85 12.6879 12.1599 12.96 12.4732 12.96H26.527C26.8725 12.96 27.15 12.6825 27.15 12.337C27.15 11.9914 26.8725 11.7139 26.527 11.7139ZM17.1157 10.7865C17.1157 10.7865 17.1157 10.7865 17.1157 10.7865C17.1157 10.3963 17.4426 10.0694 17.8328 10.0694H21.1954C21.5856 10.0694 21.9125 10.3963 21.9125 10.7865V11.7139H17.1158L17.1157 10.7865Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 26.3399V26.3399L17.1418 18.3803C17.1418 18.3803 17.1418 18.3803 17.1418 18.3803C17.1418 18.0347 16.8643 17.7572 16.5188 17.7572C16.1732 17.7572 15.8957 18.0347 15.8957 18.3803L15.8957 26.3399L15.8957 26.3405C15.8971 26.6855 16.1741 26.963 16.5198 26.963C16.8653 26.963 17.1428 26.6855 17.1428 26.3399Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5135 26.963C19.859 26.963 20.1365 26.6855 20.1365 26.3399V18.3803C20.1365 18.0347 19.859 17.7572 19.5135 17.7572C19.1679 17.7572 18.8904 18.0347 18.8904 18.3803V26.3399C18.8904 26.6855 19.1679 26.963 19.5135 26.963Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8847 26.3399V26.3475L21.8854 26.3551C21.9185 26.6804 22.1815 26.963 22.5077 26.963C22.8532 26.963 23.1308 26.6855 23.1308 26.3399V18.3803C23.1308 18.0347 22.8533 17.7572 22.5077 17.7572C22.1622 17.7572 21.8847 18.0347 21.8847 18.3803V26.3399Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.2d5a16f8a327899f618bad2495a41430.svg";
export { ForwardRef as ReactComponent };